import { toDate } from "date-fns-tz";
import { subMinutes } from "date-fns/fp";

/**
 * Used to counteract unwanted conversions to UTC by subtracting the offset from UTC based on local Time Zone.
 */
export const subLocalTimeZoneOffset = (date: Date | string | number, referenceDate: Date = new Date()) =>
  subMinutes(referenceDate.getTimezoneOffset(), toDate(date, { timeZone: "UTC" }));
